import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { makeStyles, Tooltip as MuiTooltip } from '@material-ui/core';
export function getBackgroundColor({ color }, theme) {
    var _a, _b;
    if (theme.name === 'liquidity') {
        if (color === 'light') {
            return (_a = theme.palette.tooltip) === null || _a === void 0 ? void 0 : _a.lightTooltip;
        }
        return (_b = theme.palette.tooltip) === null || _b === void 0 ? void 0 : _b.darkTooltip;
    }
    if (color === 'light') {
        return theme.palette.text.inverse;
    }
    return theme.palette.background.hint;
}
export function getTextColor({ color }, theme) {
    if (theme.name === 'liquidity')
        return theme.palette.text.inverse;
    if (color === 'light') {
        return theme.palette.text.primary;
    }
    return theme.palette.text.inverse;
}
const useStyles = makeStyles((theme) => ({
    tooltip: ({ color }) => ({
        backgroundColor: getBackgroundColor({ color }, theme),
        boxShadow: `0px 4px 16px 0px rgba(7, 18, 37, 0.2)`,
        color: getTextColor({ color }, theme),
    }),
    arrow: ({ color }) => ({
        color: getBackgroundColor({ color }, theme),
    }),
}));
export const Tooltip = React.forwardRef((_a, ref) => {
    var { children, color = 'dark', arrow = true } = _a, props = __rest(_a, ["children", "color", "arrow"]);
    const classes = useStyles({ color });
    return (_jsx(MuiTooltip, Object.assign({ ref: ref, arrow: arrow, classes: classes }, props, { children: children }), void 0));
});
export { Popover } from '@material-ui/core';
//# sourceMappingURL=Tooltip.js.map